import React, { FC, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PackageSearchSelectListItem } from "src/components/PackageSearchSelectListItem";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { ProductApi } from "../../../../../../../services/Api/Organization/types";

interface Props {
	isShown: boolean;
	onHide: () => void;
	onConfirm: (item: ProductApi) => void;
	index: number;
	onSearchProducts: (
		t: string,
		obj: Record<string, any>,
		options?: Record<string, any>,
		index?: number
	) => Promise<ProductApi[]>;
	form: UseFormReturn<any>;
	onParseOptionValue: (option: { label: string }) => string;
}

const ChangeProductModal: FC<Props> = ({
	isShown,
	onHide,
	onConfirm,
	index,
	onSearchProducts,
	form,
	onParseOptionValue,
}) => {
	const { t } = useTranslation();
	const { control, resetField, watch, setValue } = form;
	const watchedProduct = watch(`items.${index}.product`);
	const [product, setProduct] = useState<ProductApi>(watchedProduct);

	useEffect(() => {
		setValue("new_product", { name: watchedProduct.name, id: watchedProduct.id }, { shouldDirty: false });
	}, []);

	const onChange = (product: ProductApi) => {
		setProduct(product);
		resetField("new_product.name", {
			keepDirty: false,
			defaultValue: {
				name: product.name,
				label: product.name,
				id: product?.id,
			},
		});
	};

	return (
		<Modal onHide={onHide} show={isShown}>
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.document.field.change_product.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormSelectGroup
					name="new_product.name"
					errors={[]}
					getOptionValue={(option) => onParseOptionValue(option)}
					onChange={(id, obj) => onChange(obj)}
					defaultValue={{
						name: watchedProduct.name,
						label: watchedProduct.name,
						id: watchedProduct.id,
					}}
					getOptionLabel={(option) => {
						return option.product_type === "PACKAGE" ? (
							<PackageSearchSelectListItem label={option.label} />
						) : (
							option.label
						);
					}}
					isClearable={false}
					loadOptions={onSearchProducts}
					control={control}
					data-testid="new_product.name"
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button type="submit" onClick={() => onConfirm(product)}>
					{t("lib:common.action.select")}
				</Button>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ChangeProductModal;
